import React, { CSSProperties, FC, useEffect, useState } from 'react';
import beelineLogo from './images/beeline_professional_on_light_mode_2x.webp';
import { bpeConfig } from '../../bpeConfig';

const LOCAL_STORAGE_LOGO_KEY = 'tenant:logo';
const LOCAL_STORAGE_BANNER_KEY = 'tenant:bannerText';

export const useTenantAppearance = (
  tenantDataLoaded: boolean,
  { logoUid, bannerText }: { bannerText: string; logoUid?: string }
) => {
  const [logoSrc, setLogoSrc] = useState<string | undefined>(
    () => localStorage.getItem(LOCAL_STORAGE_LOGO_KEY) ?? undefined
  );
  const [label, setLabel] = useState<string>(() => localStorage.getItem(LOCAL_STORAGE_BANNER_KEY) ?? '');

  useEffect(() => {
    if (tenantDataLoaded) {
      const logoSrc = logoUid ? `/api/tenants/${bpeConfig.tenant.code}/logo/${logoUid}` : beelineLogo;
      localStorage.setItem(LOCAL_STORAGE_LOGO_KEY, logoSrc);
      localStorage.setItem(LOCAL_STORAGE_BANNER_KEY, bannerText);
      setLabel(bannerText);
      setLogoSrc(logoSrc);
    }
  }, [bannerText, logoUid, tenantDataLoaded]);

  return { label, logoSrc };
};

interface LogoProps {
  src: string | undefined;
  style?: CSSProperties;
  height?: number;
  width?: number;
}

const defaultStyles = { minHeight: 28, maxWidth: 150, maxHeight: 40 };

export const Logo: FC<React.PropsWithChildren<LogoProps>> = ({ src, style, width, height }) => {
  if (!src) {
    return null;
  }
  return <img src={src} style={style || defaultStyles} alt="Logo" width={width} height={height} />;
};
